/** Okno decyzji działu (panel): karty decyzji, kontekst wniosku, szybkie wartości i gotowe uzasadnienia. */
export const wfdPl = {
  title: { APPROVE: 'Zatwierdzenie — {step}', RETURN: 'Zwrot do uzupełnienia — {step}', REJECT: 'Odrzucenie wniosku' },
  request: 'Wniosek',
  revision: 'wersja {n}',
  choice: {
    APPROVE: { label: 'Zatwierdź', hint: 'Dane są w porządku' },
    RETURN: { label: 'Zwróć', hint: 'Do uzupełnienia' },
    REJECT: { label: 'Odrzuć', hint: 'Kończy wniosek' },
  },
  about: 'Co oceniasz',
  facts: {
    segment: 'Segment',
    customerClass: 'Klasa',
    expectedMonthlyVolume: 'Obrót miesięczny',
    creditLimitRequested: 'Wnioskowany limit',
    paymentTermDays: 'Termin płatności',
    priceNotes: 'Uwagi o cenach',
    address: 'Adres dostawy',
    deliveryDays: 'Dni dostaw',
    receivingHours: 'Godziny przyjęć',
    logisticsNotes: 'Uwagi logistyczne',
    contactName: 'Osoba kontaktowa',
    contactPhone: 'Telefon',
    contactEmail: 'E-mail',
    nip: 'NIP',
    days: '{n} dni',
  },
  others: 'Pozostałe działy',
  state: { PENDING: 'czeka', APPROVED: 'zatwierdził', RETURNED: 'zwrócił', REJECTED: 'odrzucił', SKIPPED: 'pominięty' },
  afterWaiting: 'Po Twojej decyzji wniosek czeka jeszcze na: {areas}.',
  afterLast: 'Twoja decyzja domyka wniosek.',
  requested: 'Wnioskowano: {value}',
  use: 'Użyj',
  quickPick: 'Szybki wybór',
  noLimit: 'Bez limitu',
  daysUnit: 'dni',
  weekdays: { work: 'Dni robocze', all: 'Cały tydzień', clear: 'Wyczyść' },
  suggestions: 'Częste braki',
  templates: 'Szybkie uzasadnienia',
  tpl: {
    APPROVE: { ok: 'Dane poprawne.', asRequested: 'Zatwierdzono zgodnie z wnioskiem.', lowered: 'Limit obniżony względem wniosku.' },
    RETURN: {
      nip: 'Brak lub błędny NIP.',
      address: 'Niepełny adres dostawy.',
      contact: 'Uzupełnij dane kontaktowe.',
      segment: 'Zweryfikuj segment i klasę klienta.',
      limit: 'Wnioskowany limit wymaga uzasadnienia.',
      terms: 'Zmień warunki płatności.',
    },
    REJECT: {
      duplicate: 'Klient już istnieje w bazie.',
      risk: 'Zbyt wysokie ryzyko współpracy.',
      policy: 'Niezgodne z polityką handlową.',
      potential: 'Brak potencjału sprzedażowego.',
    },
  },
  missing: { nip: 'NIP', phone: 'telefon kontaktowy', email: 'e-mail', bank: 'numer konta', hours: 'godziny przyjęć' },
  count: '{n}/{max}',
  shortcut: 'Ctrl + Enter',
  confirm: { APPROVE: 'Zatwierdź', RETURN: 'Zwróć do uzupełnienia', REJECT: 'Odrzuć wniosek' },
};

export const wfdEn: typeof wfdPl = {
  title: { APPROVE: 'Approval — {step}', RETURN: 'Return for completion — {step}', REJECT: 'Reject the request' },
  request: 'Request',
  revision: 'version {n}',
  choice: {
    APPROVE: { label: 'Approve', hint: 'Data looks fine' },
    RETURN: { label: 'Return', hint: 'Needs completion' },
    REJECT: { label: 'Reject', hint: 'Ends the request' },
  },
  about: 'What you are assessing',
  facts: {
    segment: 'Segment',
    customerClass: 'Class',
    expectedMonthlyVolume: 'Monthly volume',
    creditLimitRequested: 'Requested limit',
    paymentTermDays: 'Payment term',
    priceNotes: 'Price notes',
    address: 'Delivery address',
    deliveryDays: 'Delivery days',
    receivingHours: 'Reception hours',
    logisticsNotes: 'Logistics notes',
    contactName: 'Contact person',
    contactPhone: 'Phone',
    contactEmail: 'E-mail',
    nip: 'Tax ID',
    days: '{n} days',
  },
  others: 'Other departments',
  state: { PENDING: 'waiting', APPROVED: 'approved', RETURNED: 'returned', REJECTED: 'rejected', SKIPPED: 'skipped' },
  afterWaiting: 'After your decision the request still waits for: {areas}.',
  afterLast: 'Your decision closes the request.',
  requested: 'Requested: {value}',
  use: 'Use',
  quickPick: 'Quick pick',
  noLimit: 'No limit',
  daysUnit: 'days',
  weekdays: { work: 'Working days', all: 'Whole week', clear: 'Clear' },
  suggestions: 'Common gaps',
  templates: 'Quick reasons',
  tpl: {
    APPROVE: { ok: 'Data is correct.', asRequested: 'Approved as requested.', lowered: 'Limit lowered compared to the request.' },
    RETURN: {
      nip: 'Missing or invalid tax ID.',
      address: 'Incomplete delivery address.',
      contact: 'Complete the contact details.',
      segment: 'Verify the segment and the customer class.',
      limit: 'The requested limit needs a justification.',
      terms: 'Change the payment terms.',
    },
    REJECT: {
      duplicate: 'The customer already exists in the database.',
      risk: 'Cooperation risk is too high.',
      policy: 'Not in line with the sales policy.',
      potential: 'No sales potential.',
    },
  },
  missing: { nip: 'tax ID', phone: 'contact phone', email: 'e-mail', bank: 'bank account number', hours: 'reception hours' },
  count: '{n}/{max}',
  shortcut: 'Ctrl + Enter',
  confirm: { APPROVE: 'Approve', RETURN: 'Return for completion', REJECT: 'Reject request' },
};
